/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table, Tabs, Heading } from "@radix-ui/themes";
import "./Campaigns.css";
import RadixTable from "../../Component/RadixTable";
import PaginationBar from "../../Component/PaginationBar";
import { getCampaignList, approveCampaign, deleteCampaign } from "../../Services/DashboardApi";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import CampaignDropDown from "../../Component/CampaignDropDown";
import ApproveCampaignDropDown from "../../Component/ApproveCampaignDropDown";
import CompletedDropDown from "../../Component/CompletedCampaignDropDown";
import { useNavigate } from "react-router-dom";
import { formatTimestamp } from "../../utils/functions";
const header = ["Title", "Location", "Category", "Goal", "Date Submitted"];

const Campaigns = () => {
  const navigate = useNavigate();
  const { setloader, initAlert } = GeneralContextFunc();
  const [campaignList, setCampaignList] = useState([]);
  const [listStatus, setListStatus] = useState("Submitted");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setloader(true);
    let payload = {
      page: pageNumber,
      limit: itemsPerPage,
      status: listStatus,
    };

    getData(payload);
  };

  const getData = (payload) => {
    getCampaignList(payload)
      .then((res) => {
        // Check if the response has the expected structure
        if (!res || !res.paginatedData || !res.paginatedData.resourceData) {
          console.error("Invalid API response structure:", res);
          setCampaignList([]);
          setTotalPages(1);
          setTotalCount(0);
          setCurrentPage(1);
          setloader(false);
          return;
        }

        let data = [...res.paginatedData.resourceData];
        // Update pagination data from API response
        setTotalPages(Math.ceil(res.paginatedData.totalPage || 1));
        setTotalCount(res.paginatedData.totalCount || 0);
        setCurrentPage(res.paginatedData.currentPage || 1);
        
        // initAlert(res?.message);
        setCampaignList([
          ...data.map((elem) => ({
            id: elem.id,
            cellData: [
              elem?.title,
              [elem?.location?.city, elem?.location?.state, elem?.location?.country, elem?.location?.zipCode].filter(Boolean).join(", "),
              elem?.category,
              `$${elem?.totalApproxCost}`,
              formatTimestamp(elem?.createdAt),
            ],
          })),
        ]);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response?.data?.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        console.log("error", err);
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  //Approve campaign
  const approvalCampaign = (id) => {
    setloader(true);
    let payload = {
      id: id,
    };
    approveCampaign(payload)
      .then((res) => {
        let payload = {
          page: currentPage,
          limit: itemsPerPage,
          status: listStatus,
        };
        // initAlert(res?.message);
        getData(payload);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  //Delete a campaign from list
  const deleteCampaignBtn = (id) => {
    setloader(true);
    let payload = {
      id: id,
    };
    console.log("check");
    deleteCampaign(payload)
      .then((res) => {
        let payload = {
          page: currentPage,
          limit: itemsPerPage,
          status: listStatus,
        };
        // initAlert(res?.message);
        getData(payload);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    setloader(true);
    setCurrentPage(1);
    let payload = {
      page: 1,
      limit: itemsPerPage,
      status: listStatus,
    };

    getData(payload);
  }, [listStatus]);

  return (
    <div>
      <Heading align="left" m="5" size="8" weight="bold">
        Campaigns
      </Heading>
      <Tabs.Root value={listStatus} mx="5" mb="5">
        <Tabs.List color="gray" highContrast>
          <Tabs.Trigger onClick={() => setListStatus("Submitted")} value="Submitted">
            Submitted
          </Tabs.Trigger>
          <Tabs.Trigger onClick={() => setListStatus("Approved")} value="Approved">
            Approved
          </Tabs.Trigger>
          <Tabs.Trigger onClick={() => setListStatus("Completed")} value="Completed">
            Completed
          </Tabs.Trigger>
        </Tabs.List>
      </Tabs.Root>
      <Table.Root variant="surface" size="3" mx="5" layout="auto">
        <RadixTable
          header={header}
          data={campaignList}
          approve={approvalCampaign}
          onDelete={deleteCampaignBtn}
          DropDownComp={listStatus === "Approved" ? ApproveCampaignDropDown : listStatus === "Completed" ? CompletedDropDown : CampaignDropDown}
        />
      </Table.Root>
      {totalCount > itemsPerPage && (
        <PaginationBar 
          currentPage={currentPage} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
          totalItems={totalCount}
          itemsPerPage={itemsPerPage}
        />
      )}
    </div>
  );
};

export default Campaigns;
